import { render, staticRenderFns } from "./LoanButtons.vue?vue&type=template&id=b66cf510&scoped=true&"
import script from "./LoanButtons.vue?vue&type=script&lang=js&"
export * from "./LoanButtons.vue?vue&type=script&lang=js&"
import style0 from "./LoanButtons.vue?vue&type=style&index=0&id=b66cf510&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66cf510",
  null
  
)

export default component.exports